import { useState } from 'react';
import Validator from 'validatorjs';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia/index.js';
import PeriodicidadOptions from '../../../support/catalogos/PeriodicidadOptions.js';

const PlataformasTecnologicasForm = (props) => {
  const data = props.data;
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const handleOnChange = (event) => {
    const validator = validate({
      ...props.data,
      ...event,
    });

    props.onFormDataChange(event, {
      step: 'base',
      name: 'isValidBase',
      isValid: validator.passes(),
    });
  };

  const getRules = (data) => {
    return {
      Periodicidad: ['required', 'string'],
      NumServ: ['required', 'integer'],
      MonTotServSIVA: ['required', 'decimal:6'],
      TotalIVATrasladado: ['required', 'decimal:6'],
      TotalIVARetenido: ['required', 'decimal:6'],
      TotalISRRetenido: ['required', 'decimal:6'],
      DifIVAEntregadoPrestServ: ['required', 'decimal:6'],
      MonTotalporUsoPlataforma: ['required', 'decimal:6'],
      MonTotalContribucionGubernamental: ['decimal:6'],
    };
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidator(newValidator);

    return validator;
  };

  const rules = getRules(data);

  return (
    <Form autoComplete="off">
      <Row>
        <Col
          sm
          md={4}
        >
          <FormControl
            type="select"
            label="Periodicidad"
            name="Periodicidad"
            placeholder=""
            help=""
            rules={rules.Periodicidad}
            value={data.Periodicidad}
            options={PeriodicidadOptions}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Número de servicio"
            name="NumServ"
            placeholder=""
            help=""
            rules={rules.NumServ}
            value={data.NumServ}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Monto total servicio sin iva"
            name="MonTotServSIVA"
            placeholder=""
            help=""
            rules={rules.MonTotServSIVA}
            value={data.MonTotServSIVA}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Total iva trasladado"
            name="TotalIVATrasladado"
            placeholder=""
            help=""
            rules={rules.TotalIVATrasladado}
            value={data.TotalIVATrasladado}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Total iva retenido"
            name="TotalIVARetenido"
            placeholder=""
            help=""
            rules={rules.TotalIVARetenido}
            value={data.TotalIVARetenido}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Total isr retenido"
            name="TotalISRRetenido"
            placeholder=""
            help=""
            rules={rules.TotalISRRetenido}
            value={data.TotalISRRetenido}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Diferencia iva entregado prestación de servicio"
            name="DifIVAEntregadoPrestServ"
            placeholder=""
            help=""
            rules={rules.DifIVAEntregadoPrestServ}
            value={data.DifIVAEntregadoPrestServ}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Monto total por uso de plataforma"
            name="MonTotalporUsoPlataforma"
            placeholder=""
            help=""
            rules={rules.MonTotalporUsoPlataforma}
            value={data.MonTotalporUsoPlataforma}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          sm
          md={4}
        >
          <FormControl
            type="number"
            label="Monto total contribución gubernamental"
            name="MonTotalContribucionGubernamental"
            placeholder=""
            help=""
            rules={rules.MonTotalContribucionGubernamental}
            value={data.MonTotalContribucionGubernamental}
            onChange={handleOnChange}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default PlataformasTecnologicasForm;
